<template>
    <b-sidebar id="filter-product-sidebar" bg-variant="white" no-header right shadow backdrop>
      <template #default="{ hide }">
        <div class="container-wrapper">
          <section class="header">
            <div class="guides-info-title">Filtros</div>
            <div class="actions">
              <Close class="close" @click="hide" />
            </div>
          </section>
  
          <section class="guides-summary-items">
            <b-form-group>
              <div class="search-container">
                <Search class="icon-search" />
                <b-form-input
                  id="query"
                  v-model="filters.name"
                  debounce="500"
                  placeholder="Nome do produto, solicitante ou solicitação"
                />
              </div>
            </b-form-group>

            <b-form-group>
              <label for="period">
                Período de cadastro
              </label>
              <Periods 
                @select="handlePeriod"
                ref="periodsRef" 
              />
            </b-form-group> 

            <b-form-group>
              <label for="period">
                Número
              </label>
              <b-form-input
                  id="product_number"
                  v-model="filters.number"
                  debounce="500"
                  placeholder="Numero do produto"
                  :option-height="40"
                  class="with-border"
                  length="10"
                  ref="product_stock_request_number"
                  :formatter="formatNumber"
                  maxlength="16"
                  
                />
              
            </b-form-group>

            <b-form-group>
              <label for="period">
                Categoria
              </label>
              <!-- 'product_category_id', -->
        
              <multiselect
                id="product_category_id"
                autocomplete="off"
                v-model="helperFilters.product_category_id"
                :options="productCategoriesOptions"
                :option-height="40"
                :showLabels="false"
                :searchable="true"
                track-by="value"
                label="label"
                placeholder="Selecionar"
                class="with-border"
                ref="product_stock_request_product_category_id"
                @input="(value) => { filters.product_category_id = value.value }"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label for="period">
                Classe
              </label>
              <!-- 'product_class_id', -->
              <multiselect
                  id="product_class_id"
                  autocomplete="off"
                  v-model="helperFilters.product_class_id"
                  :options="productClassOptions"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecionar"
                  class="with-border"
                  ref="product_stock_request_product_class_id"
                  @input="(value) => { filters.product_class_id = value.id }"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label for="period">
                Cadeia fria
              </label>
              <!-- cold_chain_medicine -->
              <multiselect
                  id="cold_chain_medicine"
                  autocomplete="off"
                  v-model="helperFilters.cold_chain_medicine"
                  :options="globalOptions"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecionar"
                  class="with-border"
                  ref="product_stock_request_cold_chain_medicine"
                  @input="(value) => { filters.cold_chain_medicine = value.id }"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>
            <b-form-group>
              <label for="period">
                Psicotrópico
              </label>
              <!-- psychotropic_medication -->
              <multiselect
                  id="psychotropic_medication"
                  autocomplete="off"
                  v-model="helperFilters.psychotropic_medication"
                  :options="globalOptions"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecionar"
                  class="with-border"
                  ref="product_stock_request_manufacturer_id"
                  @input="(value) => { filters.psychotropic_medication = value.id }"

              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>
            <b-form-group>
              <label for="period">
                Unidade de venda
              </label>
              <!-- product.sales_unit?.name -->
              <multiselect
                  id="sales_unit_id"
                  autocomplete="off"
                  v-model="helperFilters.sales_unit_id"
                  :options="measureUnitsOptions"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecionar"
                  class="with-border"
                  ref="product_stock_request_sales_unit_id"
                  @input="(value) => { filters.sales_unit_id = value.id }"

              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>
            <b-form-group>
              <label for="period">
                Quantidade mínima
              </label>
              <!-- product_balance -->
                <multiselect
                id="product_balance"
                autocomplete="off"
                v-model="helperFilters.minimum_quantity"
                :options="minimumQuantityOptions"
                track-by="value"
                label="label"
                :option-height="40"
                :showLabels="false"
                :searchable="true"
                placeholder="Selecionar"
                class="with-border"
                ref="product_balance"
                @input="(value) => { filters.minimum_quantity = value.id }"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
              </multiselect>
            
            </b-form-group>
            
            <b-form-group>
              <label for="product_stock_request_manufacturer_id">Fabricante</label>
              <multiselect
                  id="manufacturer_id"
                  autocomplete="off"
                  v-model="helperFilters.manufacturer_id"
                  :options="manufacturersOptions"
                  :option-height="40"
                  :showLabels="false"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecionar"
                  class="with-border"
                  ref="product_stock_request_manufacturer_id"
                  @input="(value) => { filters.manufacturer_id = value.id }"
              >
                <template slot="caret">
                  <div class="chevron">
                    <ChevronDown />
                  </div>
                </template>
                <template slot="noOptions"> Nenhuma opção </template>
                <template slot="noResult"> Nenhum resultado </template>
              </multiselect>
            </b-form-group>
 
          </section>
  
          <div class="wrapper-button">
            <b-button block variant="primary" @click="saveChanges">
              Confirmar
            </b-button>
  
            <b-button
              @click="resetForm"
              variant="outline-primary"
            >
              Redefinir
            </b-button>
  
          </div>
        </div>
      </template>
    </b-sidebar>
  </template>
  
  <script>

  import { getCurrentClinic, userHasPermission } from '@/utils/localStorageManager'

  export default {
    components: {
      Close: () => import('@/assets/icons/close.svg'),
      Search: () => import('@/assets/icons/search.svg'),
      ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
      Periods: () => import('@/components/General/Periods'),
    },
    props: {
      batchId: String,
    },
    mounted() {
      this.getProducts('');
      this.getManufacturersFilter();
      this.getWarehouseProductCategoriesFilter();
      this.getProductClassOptionsFilter();
      this.getMeasureUnitsOptionsFilter();

    },
    data() {
      return {
        clinic: getCurrentClinic(),
        summary: {},
        helperFilters: {},
        filters: {
          request_date: {
            type: 'create',
            'start': null,
            'end': null
          },
        },
        productOptions: [],
        productClassOptions: [],
        globalOptions: [
          {
            id: 0,
            name: 'Não'
          },
          {
            id: 1,
            name: 'Sim',
          },
          
        ],
        langDatePicker: {
          formatLocale: {
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
          }
        },
        manufacturersOptions:[],
        productCategoriesOptions: [],
        measureUnitsOptions: [],
        minimumQuantityOptions: [
            { label: 'Selecionar', id: null }, 
            { label: 'Abaixo do definido', id: 1 },
            { label: 'Acima do definido', id: 2 }
        ],

      }
    },
    computed:{
      optionsNumeros(){
        const numbersValues = this.productOptions?.map(item => item.number)
        numbersValues.sort((a, b) => a - b);
        return numbersValues;
      },
      productBalanceOptions(){
        if (!this.productOptions) {
            return []; // Ou trate o caso de productOptions ser null conforme necessário
          }

        const filteredOptions = this.productOptions.filter(item => (item.balance || 0) !== 0);
        const balanceValues = filteredOptions.map(item => item.balance || 0);
        // Ordena os valores de balance do menor para o maior
        balanceValues.sort((a, b) => a - b);
        return balanceValues;
      }

    },
    methods: {
      userHasPermission,
      formatNumber(e){
          return String(e).replace(/[^0-9]/g, '').substring(0,16);
      },
      handlePeriod(value) {
        this.filters.request_date.type = 'create';
        this.filters.request_date.start = value.start;
        this.filters.request_date.end = value.end;
      },
      getProductClassOptionsFilter(){
        this.api.getWarehouseProductClasses(this.clinic.id, {status: true})
        .then(res => {
          this.productClassOptions = res.data;
        });
      },
      getMeasureUnitsOptionsFilter(){
        this.api.getMeasureUnits()
        .then(res => {
          this.measureUnitsOptions = res.data;
        });
      },
      getManufacturersFilter(){
      this.api.getWarehouseManufacturers(this.clinic.id, {status: true})
      .then(res => {
        this.manufacturersOptions = res.data;
      });
    },
    getWarehouseProductCategoriesFilter(){
      this.api.getWarehouseProductCategories(this.clinic.id, {status: true})
      .then(res => {
        if (res && res.data) {
            this.productCategoriesOptions = res.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
          } else {
            this.productCategoriesOptions = [];
          }
      });
    },
      getProducts(query) {
        this.api.getProducts(this.clinic.id, 1, query)
            .then(res => {
              this.productOptions = res.data.data.map(item => ({
                ...item,
              }));
            })
            .catch(err => this.$toast.error(err.message))
      },
    
    
      async saveChanges() {
        const isLoading = this.$loading.show()
        const filters = this.filters;

        if(!filters.request_date?.start || !filters.request_date?.end) delete filters.request_date
        
        try {
          this.$emit('change', filters);  
          this.$emit('updateFilterApplied');  
          this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')      
        } catch (err) {
          this.$toast.error(err.message)
        } finally {
          isLoading.hide()
        }
      },
      async resetForm() {
        this.filters = {
          request_date: {
            type: 'create',
            'start': null,
            'end': null
          },
          number: null,
          name: null,
          product_id: null,
          product_class_id: null,
          manufacturer_id: null,
          sales_unit_id: null,
          product_balance: null,
          psychotropic_medication: null,
          cold_chain_medicine: null,  
          product_category_id: null,
        };
        this.helperFilters = {};

        this.$refs.periodsRef.clearCustom();
  
        this.$emit('change', {});
        this.$emit('updateFilterApplied');  
        this.$root.$emit('bv::toggle::collapse', 'filter-product-sidebar')    
      },

      
    },
  }
  </script>
  
  <style lang="scss">
  .search-container {
    display: flex;
    flex-direction: row;
    position: relative;
  
    .icon-search {
      position: absolute;
      width: 24px;
      height: 24px;
      stroke: var(--neutral-500);
      margin: 7px 8px;
    }
  
    input {
      padding-left: 40px !important;
    }
  
  }
  
  #filter-product-sidebar {
    min-width: 450px;
  
    .title {
      display: flex;
      flex-direction: row;
  
      h4 {
        color: var(--dark-blue);
        font-weight: 700;
        font-size: 18px;
        margin-right: 20px;
      }
  
      h5 {
        color: var(--blue-600);
        font-weight: 600;
        font-size: 18px;
  
        span {
          color: var(--neutral-500);
        }
      }
    }
  
    .guides-summary {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 5px;
      padding: 20px;
      border-radius: 8px;
      border: 1px dashed var(--neutral-300);
      background: var(--neutral-100);
  
      .guides-summary-row {
        display: grid;
        grid-template-columns: auto 1fr auto 3fr;
        gap: 10px;
      }
  
      dt {
        color: var(--neutral-700);
      }
  
      dd {
        margin: 0;
      }
    }
  
    .guides-container {
      display: flex;
      flex-direction: column;
      width: 100%;
  
      .guide-container {
        margin: 10px 0;
      }
    }
  
    .container-wrapper {
      padding: 0 1rem;
    }
  
    .header {
      display: flex;
      width: 100%;
      padding: 1rem 0;
      justify-content: space-between;
      align-items: center;
    }
  
    .guides-info-title {
      font-family: 'Red Hat Display';
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      color: var(--dark-blue);
    }
  
    .actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
    }
  
    .optional {
      font-size: 14px;
      color: var(--type-placeholder);
    }
  
    .close {
      width: 25px;
      fill: var(--neutral-500);
    }
  
    .wrapper-button {
      width: 100%;
      display: flex;
      margin: 20px 0 !important;
      flex-direction: column;
  
      button {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }
  
      .btn-primary {
        color: var(--neutral-000);
      }
  
      .btn-outline-primary {
        margin-top: 10px;
        color: var(--blue-500);
      }
  
      .dropdown-item {
        font-weight: 400;
      }
    }
  }
  </style>